var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userRol.id==3 || _vm.userRol.id==2)?_c('div',{staticClass:"float-right mr-5"},[_c('b-button',{attrs:{"to":{ name: 'editar-usuario', params: { id: _vm.personaFk } },"variant":"primary"}},[_vm._v(" Editar Perfil ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }